import { useEffect, useState, useRef } from "react";
import arrowDownDropdown from "./../CoachPaintAssets/arrow-down-dropdown.svg";
import "./ToolsDropdown.css";

const ToolsDropdown = (props) => {
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const dropdownRef = useRef(null);
    const [idx, setIdx] = useState(0);

    useEffect(()=>{
      function handleClickOutside(e) {
       if(setDropdownOpen && !dropdownRef.current.contains(e.target))
         setDropdownOpen(false)
      }
      window.addEventListener("click", handleClickOutside);
      return() => window.removeEventListener("click", handleClickOutside);
    })

    useEffect(() => {
      if(props.checkStamp){
        setIdx(-1);
      }
    }, [props.checkStamp])

    const handleToggleDropdown= () => {
      setDropdownOpen(!dropdownOpen);
    }

    return (
      <div className="webapp-paint-coach-geometric-dropdown-container" ref={dropdownRef}>
        <span className="webapp-paint-geometric-dropdown-labels"> {props.title} </span>
        <div className="webapp-paint-geometric-dropdown-placeholder" onClick={(e) => handleToggleDropdown(e)}>
          <img className={`${!props.checkStamp ? 'canvas-geometric-selected' : '' } webapp-paint-stamp-placeholder-geometric`} src={(!props.checkStamp) ? props?.stamps[idx].image : props?.stamps[0].image}></img>
          <img className="webapp-paint-geometric-dropdown-arrow" src={arrowDownDropdown}/>
          {dropdownOpen === true ? (
            <div className="webapp-coach-paint-geometric-dropdown">
                {props.stamps.map((figure, index) => (
                        <div key={index} className={`coach-paint-geometric-dropdown-row`}
                        onMouseEnter={() => {
                            props.setCurrentMessageType(figure.id.includes("arrow") ? "arrow" : "square");
                        }}
                        onMouseLeave={() => {
                            props.setCurrentMessageType(null);
                        }}
                        onClick={() => {
                            props.setSelectedStamp(null);
                            props.setTool(figure.id);
                            props.setCurrentMessageType(null);
                            setIdx(index);
                        }}>
                            <div className="webapp-coach-paint-geometric-option">
                              <img className={idx === index ? "canvas-geometric-selected" : ""} src={figure?.image} alt="Image" ></img>
                            </div>
                            {figure.label &&
                              <span>{figure.label}</span>
                            }
                        </div>
                ))}
            </div>) : null
          }
        </div>
      </div>
    )
}

export default ToolsDropdown;